import React, { useEffect, useState } from 'react';
import { Modal, Switch, Table } from 'antd';
import Search from 'antd/es/input/Search';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { getShowSelectVehicleModal, showSelectVehicleModal } from '../../store/app-ui.store';
import {
  fetchMinimalLicenseAndVehicle,
  getMinimalVehicles,
  getSelectedVehicles,
  setSelectedVehicle,
  getVehicleSelectionMode,
} from '../../store/drivers.store';

const SelectVehicleModal = (): JSX.Element => {
  const showModal = useAppSelector(getShowSelectVehicleModal);
  const allVehicles = useAppSelector(getMinimalVehicles);
  const mode = useAppSelector(getVehicleSelectionMode);
  const selectedVehicles = useAppSelector(getSelectedVehicles);
  const [filter, setFilter] = useState<string>();
  const dispatch = useAppDispatch();
  const updateTimestamp = useAppSelector((state) => state.vehicle.updateTimestamp);

  useEffect(() => {
    if (!showModal) return;
    dispatch(fetchMinimalLicenseAndVehicle(0));
  }, [dispatch, updateTimestamp, showModal]);

  const handleOK = () => {
    dispatch(showSelectVehicleModal(false));
  };

  if (!showModal) {
    return <div />;
  }

  const dataSource = filter
    ? allVehicles.filter((value) => value.plateNumber && value.plateNumber.toLowerCase().includes(filter.toLowerCase()))
    : allVehicles;

  return (
    <Modal visible={showModal} title="Select Vehicles" onOk={handleOK} onCancel={handleOK} cancelText={() => null}>
      <Search value={filter} onChange={(e) => setFilter(e.target.value)} placeholder="Search Vehicle" />
      <Table
        columns={[
          { title: 'Name', dataIndex: 'plateNumber' },
          { title: 'Capacity', dataIndex: 'capacity' },
          {
            title: 'Select',
            dataIndex: 'select',
            render: (_, record) => {
              const isSelected = !!selectedVehicles[record.plateNumber];
              const isSingleMode = mode === 'single';
              const alreadySelected = Object.values(selectedVehicles).some(Boolean);

              return (
                <Switch
                  checked={isSelected}
                  onChange={(checked) => {
                    if (isSingleMode) {
                      // Only one allowed – clear all and select new
                      Object.keys(selectedVehicles).forEach((id) => {
                        if (id !== record.plateNumber) {
                          dispatch(setSelectedVehicle({ id, selected: false }));
                        }
                      });
                    }
                    dispatch(
                      setSelectedVehicle({
                        id: record.plateNumber,
                        selected: checked,
                      }),
                    );
                  }}
                  disabled={isSingleMode && !isSelected && alreadySelected}
                />
              );
            },
          },
        ]}
        dataSource={dataSource}
      />
    </Modal>
  );
};

export default SelectVehicleModal;
